module.exports = __webpack_public_path__ + "img/DE03696.ea08486d.png";